import { render, staticRenderFns } from "./nOrdGenericInput.vue?vue&type=template&id=0c599b08&"
import script from "./nOrdGenericInput.vue?vue&type=script&lang=js&"
export * from "./nOrdGenericInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports